export default "__VITE_ASSET__d06bb0fa__"